import BaseValue, { SetPropertyActionValue } from './BaseValue'

export default class PropertyValue extends BaseValue {
  declare type: SetPropertyActionValue.Property
  property_index!: number
  transform!: any
}
